<template>
    <div v-if="!loading">
        <div class="main-background"></div>
        <div v-if="displayShadeOverlay" class="shade-overlay"></div>

        <contact-popup v-if="displayContactPopup" v-on:close="closeContact"/>
        <about-popup v-if="displayAboutPopup" v-on:close="closeAbout"/>

        <div class="nav-wrapper" :class="{'is-scrolled': isScrolled, 'is-expanded': navExpanded}">
            <nav role="navigation">
                <div class="header-top">
                    <a v-if="displayBackButton" id="nav-back" href="#" @click.prevent='onBack()'>
                        <span>
                            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'chevron-circle-left']" size="lg"/>
                        </span>
                    </a>
                    <div class="statusbar">
                        <div class="progressbar" :class="{'hidden': !isAssignment}">
                            <img src="./images/kit_spuit.svg">
                            <div class="outer-ring">
                                <div class="inner-ring" :style="{'--progress': $store.state.headerData.progress}">
                                    <span>{{Math.round($store.state.headerData.progress * 100) + '%'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a id="nav-toggle" href="#" @click.prevent='toggleNav()'>
                        <span v-if="navExpanded">
                            <font-awesome-icon class="font-awesome-icon" :icon="['far', 'times-circle']" size="lg"/>
                        </span>
                        <span v-else>
                            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'bars']" size="lg"/>
                        </span>
                    </a>
                </div>
                <ul :class="{expanded: navExpanded}">
                    <li><a href="#" @click.prevent="toLanding">Home</a></li>
                    <li v-if="$store.state.hasAccessToCourse != 2"><a href="#" @click.prevent="toStartQuiz">Naar start quiz</a></li>
                    <li v-if="$store.state.hasAccessToCourse == 2"><a href="#" @click.prevent="toStartCursus">Naar start introductie cursus</a></li>
                    <li><a href="#" @click.prevent="openContact">Vragen? Bel ons gerust</a></li>
                    <li><a href="#" @click.prevent="openAbout">Wie heeft dit gemaakt?</a></li>                    
                    <li v-if="!$store.state.loggedIn"><a href="#" @click.prevent="toRegister">Inloggen</a></li>
                    <li v-if="$store.state.loggedIn"><a href="#" @click.prevent="logout">Uitloggen</a></li>
                </ul>
            </nav>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import Auth from '../services/Auth';
    import BackEnd from '../services/Backend';

    import ContactPopup from './ContactPopup.vue';
    import AboutPopup from './AboutPopup.vue';

    export default {
        components : {
            'contact-popup': ContactPopup,
            'about-popup': AboutPopup,
        },
        'data': function () {
            return { 
                loading: true,
                navExpanded: false,
                isScrolled: false,
                displayContactPopup: false,
                displayAboutPopup: false,
                hasAccessToCourse: false,
            }
        },
        'watch': {
            '$route' () {
                this.navExpanded = false;
                this.displayContactPopup = false;
                this.displayAboutPopup = false;
                window.scrollTo(0, 0);
            },
            'isAssignment' (newVal, oldVal) {
                console.log('watch isAssignment', newVal, oldVal);
                if(oldVal && !newVal && this.$store.state.headerData.progress != 0) {
                    this.$store.commit('setHeaderData', Object.assign(this.$store.state.headerData, {progress: 0}));
                }
            }
        },
        'computed': {
            isAssignment: function() {
                return this.$route.name === 'assignment';
            },
            displayShadeOverlay: function() {
                if(this.navExpanded) {
                    return true;
                }
                
                return false;
            },
            displayBackButton: function() {
                if(this.$route.name === 'privacy') { return true; }
                if(this.$route.name === 'disclaimer') { return true; }
                if(this.$route.name === 'cookies') { return true; }

                return false;
            }
        },
        'methods': {
            toggleNav: function() {
                this.navExpanded = !this.navExpanded;
            },
            logout() {
                Auth.logout();                
                this.$router.push({ name: 'landing' }).catch(err => { this.navExpanded = false; });
            } ,
            toRegister() {
                this.$router.push({ name: 'register' }).catch(err => { this.navExpanded = false; });
            },
            toLanding() {
                this.$router.push({ name: 'landing' }).catch(err => { this.navExpanded = false; });
            },
            toStartQuiz() {
                if(this.$store.state.loggedIn) {
                    this.$router.push({ name: 'loadassignment' }).catch(err => { this.navExpanded = false; });
                } else {
                    this.toRegister();
                }
            },
            toStartCursus() {                
                this.$router.push({ name: 'assignmentgrid' }).catch(err => { this.navExpanded = false; });                
            },
            openContact() {
                this.displayContactPopup = true;
            },
            closeContact() {
                this.displayContactPopup = false;
            },
            openAbout() {
                this.displayAboutPopup = true;
            },
            closeAbout() {
                this.displayAboutPopup = false;
            },
            onBack() {
                this.$router.back();
            }
        },
        mounted() {
            console.log(this.$route.name);           

            this.isScrolled = window.scrollY != 0;

            window.addEventListener('scroll', () => {
                this.isScrolled = window.scrollY != 0;
            })

            Auth.loginWithRefreshToken().then(() => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    }
</script>    